module.exports = __webpack_public_path__ + "static/media/holding_calendar.74303daa.svg";